import {useFieldArray, useFormContext} from "react-hook-form";

import {ServiceField} from "@/lib/constants/service.ts";
import {ThirdPartyComponent, ThirdPartyService} from "@/lib/queries/checks.ts";
import {ThirdPartyComponentv2} from "@/pages/checks/components/form/fields/components/ThirdPartyComponentv2.tsx";
import {ThirdPartySubComponentSelectField} from "@/pages/checks/components/form/fields/ThirdPartySubComponentSelectField.tsx";

import styles from "./ThirdPartySubComponent.module.scss";

interface ThirdPartySubComponentProps {
  componentIndex: number;
  group: ThirdPartyService;
}

export const ThirdPartySubComponent = ({componentIndex, group}: ThirdPartySubComponentProps) => {
  const {watch, control} = useFormContext();
  const subComponentFieldName = `${ServiceField.THIRD_PARTY_COMPONENTS}.${componentIndex}.sub_components`;
  const subComponents: ThirdPartyComponent[] = watch(subComponentFieldName) || [];
  const subTitleCount = watch(`${ServiceField.THIRD_PARTY_COMPONENTS}.${componentIndex}.sub_title_count`);
  const {prepend, remove, fields} = useFieldArray({control, name: subComponentFieldName});

  return (
    <>
      <ThirdPartySubComponentSelectField
        className="mt-3"
        groupFieldName={ServiceField.THIRD_PARTY_GROUP}
        componentsFieldName={ServiceField.THIRD_PARTY_COMPONENTS}
        componentIndex={componentIndex}
        placeholder="Search components..."
        prepend={prepend}
      />
      {fields.length > 0 && (
        <>
          <div className={styles.subComponentList}>
            {fields.map((field, subComponentIndex) => {
              const subComponent = subComponents[subComponentIndex];
              if (!subComponent) return null;
              return (
                <ThirdPartyComponentv2
                  key={field.id}
                  variant="subComponent"
                  group={group}
                  body={subComponent.display_sub_title || subComponent.sub_title}
                  index={subComponentIndex}
                  remove={remove}
                />
              );
            })}
          </div>
          <div className="pulseTextBodySmall pulse-color-gray-600 mt-3">
            {fields.length} of {subTitleCount} selected.
          </div>
        </>
      )}
    </>
  );
};
